export default __webpack_public_path__ + "static/media/leval_1.3b1de1c7.png";